import { gql } from "@apollo/client";

export const FETCH_OBJECT_TAGS = gql`
  query FETCH_OBJECT_TAGS(
    $contentTypeAppLabel: String!
    $contentTypeName: String!
    $objectId: ID!
  ) {
    taggingObjectTags(
      contentTypeAppLabel: $contentTypeAppLabel
      contentTypeName: $contentTypeName
      objectId: $objectId
    ) {
      id
      value
    }
  }
`;
